import React, { useEffect, useState, useContext } from 'react';

import { ScreenContext } from '../contexts/ScreenContext';

import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TopAppBar from './TopAppBar';
import SideMenu from './SideMenu';

const drawerWidth = 256;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth,
    }
  },
  footer: {
    paddingTop:20,
    paddingBottom:10
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Portal(props) {
  const classes = useStyles();
  const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const { snackbarMessage } = useContext(ScreenContext);

  const [mobileOpen, setMobileOpen] = useState(false);
  
  const [open, setOpen] = useState(false);

  const showSnackbar = () => {
    setOpen(true);
  };

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeDrawer = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    if(matches && mobileOpen){
      setMobileOpen(false);
    }
  },[matches]);

  useEffect(()=>{

    if(snackbarMessage.message != '') {
        showSnackbar();
    }
    
  },[snackbarMessage])

  return (
    <React.Fragment>
    <div className={classes.root}>
      <CssBaseline />
      <TopAppBar handleDrawerToggle={handleDrawerToggle} />
      <SideMenu mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} closeDrawer={closeDrawer}  />
      <main className={classes.content}>
        <Toolbar />        
        
        { props.children }

        <Grid container>
          <Grid item xs={12} className={classes.footer}>
              <Typography align="center">{`© 1992-${new Date().getFullYear()} Personalized Computer Systems, Inc.`}</Typography>
          </Grid>
        </Grid>
      </main>

      <Snackbar 
        open={open} 
        autoHideDuration={2000} 
        onClose={handleCloseSnackbar} 
        anchorOrigin={ {vertical: 'bottom', horizontal: 'center'} }
        style={{ whiteSpace:'pre-wrap' }} >
        <Alert onClose={handleCloseSnackbar} severity={snackbarMessage.severity}>{snackbarMessage.message}</Alert>
      </Snackbar>
    </div>
    </React.Fragment>
  );
}
